var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c("DataSetContextMenuRecycle", {
        ref: "datasetMenu",
        on: {
          reload: function ($event) {
            return _vm.refresh()
          },
        },
      }),
      _vm._v(" "),
      _c(
        "Subheader",
        { attrs: { dense: "", title: "Recycle Bin", "no-search": "" } },
        [
          _c(
            "SecondaryBtn",
            {
              attrs: { light: "", color: "info", icon: "refresh" },
              on: {
                click: function ($event) {
                  return _vm.refresh()
                },
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("Refresh")) + "\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "files-table",
        class: {
          "five-items": _vm.tempModel.rowsPerPage === 5,
          "ten-items": _vm.tempModel.rowsPerPage === 10,
          "twenty-five-items": _vm.tempModel.rowsPerPage === 25,
        },
        attrs: {
          headers: _vm.dataHeaders,
          items: _vm.fileItems,
          pagination: _vm.tempModel,
          "total-items": _vm.totalItems,
          loading: _vm.searchLoading,
        },
        on: {
          "update:pagination": function ($event) {
            _vm.tempModel = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function (props) {
              return [
                _c("td", { staticClass: "name-td maximize no-wrap" }, [
                  _c(
                    "span",
                    [
                      _c("v-icon", { attrs: { small: "" } }, [
                        _vm._v("save_alt"),
                      ]),
                      _vm._v(
                        "\n          " + _vm._s(props.item.Name) + "\n        "
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "no-wrap" }, [
                  _vm._v(
                    "\n        " + _vm._s(props.item.FileType) + "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "no-wrap" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.formatDateTime(props.item.DeleteDateTime, {
                          format: _vm.prettyDateTimeFormat,
                          excludeUtcText: true,
                        })
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "no-wrap" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.formatDateTime(props.item.DateCreated, {
                          format: _vm.prettyDateTimeFormat,
                          excludeUtcText: true,
                        })
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass: "text-xs-center no-wrap",
                    staticStyle: { width: "140px" },
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "box-shadow",
                        attrs: { loading: props.item.loading, icon: "" },
                        on: {
                          click: function ($event) {
                            return _vm.$refs.datasetMenu.show(props.item)
                          },
                        },
                      },
                      [
                        _c("v-icon", { attrs: { color: "info" } }, [
                          _vm._v("more_vert"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }